var req = require("!!/Users/dw/Exploros/front-end/webpack/loaders/pug-template-loader.js!/Users/dw/Exploros/front-end/elements/web/template.jade");
module.exports = (req['default'] || req).apply(req, [])